import { Component, ViewChild, AfterViewInit, OnInit , Inject} from '@angular/core';
import { Router, RouterModule, Routes, Route, ActivatedRoute} from '@angular/router';
import { Observable } from 'rxjs';
import { Login } from './Login';

import { RoutesService } from '../Routes/routes.service';

import { SecurityService } from '../Security/security.service';
import { LogService } from '../Abstract/log.service';
import { VisualsService } from '../Abstract/visuals.service';
import { ConfigService } from '../../Core/Abstract/config.service';
import { HomeService } from '../../Menus/Home/home.service';
import { EventsEmitterService } from '../../Core/Abstract/emitter.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { MenuService } from '@core/Abstract/shared/sidebar/menu.service';
import { TranslateService } from '@ngx-translate/core';


@Component({
    selector: 'login',
    templateUrl: 'login.component.html',
    providers : [MenuService, RoutesService, HomeService]
})

export class LogInComponent implements OnInit,AfterViewInit {

    @ViewChild('msgModal',{static: false}) public msgModal: ModalDirective;

    /*
     *  Modal handling
     */

    public showChildModal(): void {
        this.msgModal.show();
    }

    public hideChildModal(): void {
        this.msgModal.hide();
    }

    protected loading: boolean = false;

    protected loginerror = false;
    protected loginmsg = "";
    protected loggedOutMsg = "You've successfully logged out.";
    protected expired = false;
    protected resetPassword = false;
    protected loggedOut = false;
    protected chpwd = false;
    protected redirectTitle = "";
    protected redirectMsg = "";

    protected auth_type = "";
    protected auth_rev = "";
    showPassword : boolean = false;
    showPasswordClass : string = 'mdi-eye-off';

    constructor(protected router: Router,public translate:TranslateService,
                protected menusService: MenuService, protected routesService: RoutesService, 
                protected securityService: SecurityService, protected logger: LogService,
                protected visualsService: VisualsService, protected configService: ConfigService,
                protected homeService:HomeService, protected eventsEmitterService :EventsEmitterService,
                protected route: ActivatedRoute) {

        //this.securityService.clearStorages();
        localStorage.setItem('langId', this.configService.getLangDefault() ? this.configService.getLangDefault().toString() : '2' );
    }
    currentLang =  this.configService.getCurrentLocaleStr();

    ngAfterViewInit(){
        if (this.expired || this.chpwd || this.loggedOut || this.resetPassword) {
            this.showChildModal();
        }
    }

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            this.logger.log(params)
            if (params['expired']) {
                this.expired = true;
                this.redirectTitle = "Logout";
                this.redirectMsg = "You were logged out due to inactivity.";
                
            }
            if (params['chpwd']) {
                this.chpwd = true;
                this.redirectTitle = "Success";
                this.redirectMsg = "Password Changed Successfully!";
            }      
            if (params['loggedOut']) {
                this.loggedOut = true;
                this.redirectTitle = "Logout";
                this.redirectMsg = "You've successfully logged out.";
            }   
            if (params['resetPassword']) {
                this.resetPassword = true;
                this.redirectTitle = "Success";
                this.redirectMsg = "Your password has been reset successfully";
            }
           
        });
        this.route.queryParams.subscribe(
            params => {
                if(params['lang']){
                    this.changeLang(params.lang);
                }     
        })
    }

    private goToRegister() {
        this.router.navigateByUrl('register');
    }

    private goToForgotPass() {
        this.router.navigateByUrl('forgotPassword');
    }

    private model:Login = new Login("password", "", "");


    public doLogin(login: Login){
        this.loading = true;
        this.loginerror = false;

        //real
        this.securityService.sendTokenRequest(login).subscribe(
            data => {
                this.logger.log(data);
                if(data){

                    this.securityService.saveToStorage('access_token', data['access_token']);
                    this.securityService.saveToStorage('refresh_token', data['refresh_token']);


                    Promise.all( this.saveVisualsToStorage() ).then(
                        (success) => {
                            //this.loading = false;
                            this.routesService.getRoutes('menu/home');
                            localStorage.setItem('userName',login.username); 
                        },
                        (error) => {
                            this.loading = false;
                            this.loginerror = true;
                            this.loginmsg = 'Error. Please try again.';
                        }
                    )
                    
                    return true;
                } 
            },
            error => {
                this.loading = false;
                this.loginerror = true;
                this.loginmsg = error.error.error_description;
                
                //disabled , locked, expired
                if( this.loginmsg.indexOf('expired') > 0 ) { 
                    localStorage.setItem('changePassword' , this.model.username )
                    this.router.navigateByUrl('changePassword');
                }
                if( this.loginmsg.indexOf('disabled') > 0 ) {
                    localStorage.setItem('confirm' , this.model.username )
                    this.router.navigateByUrl('confirm');
                }

                this.logger.error(error);
                return Observable.throw(error);
            }
            
        );
    }

    protected saveVisualsToStorage(){
        let langs = this.configService.getLangs();
        this.logger.log(langs);

        let promises = [];  


        //get all menus and visuals
        //and all <select> lookup/param/currency options
        langs.forEach(element => {
            localStorage.setItem("lkpCellRender" + element['id'],"{}");

            promises.push(this.menusService.getMenusForUser(element['id']).toPromise());

            promises.push(this.visualsService.getAllVisuals(element['id']).toPromise());

            //additional lookups go here
            promises.push(this.visualsService.getAllLookups(element['id']).toPromise());

            promises.push(this.visualsService.getCurrencies(element['id']).toPromise());     
        });

        //home data
        // promises.push(this.homeService.getCurrentUser().toPromise());    
        return promises;

    }
    public changeLang(langId) {
        localStorage.setItem('langId', langId);
        this.eventsEmitterService.languageChange.emit(langId);
        this.translate.use(langId);
      }    

      public showPasswordClick(){
        this.showPassword = !this.showPassword;
        this.showPasswordClass = this.showPassword ? 'mdi-eye' : 'mdi-eye-off';
      }
}